import { apiClient } from './client';
import type { User, UserProfile, CookingActivity } from '@/types';

interface UserResponse {
  user: User;
}

interface ProfileResponse {
  profile: UserProfile;
}

interface CookingActivityResponse {
  activities: CookingActivity[];
  stats: {
    total_cooked: number;
    current_streak: number;
    longest_streak: number;
  };
}

export async function getCurrentUser(): Promise<User> {
  const data = await apiClient.get<UserResponse>('/user');
  return data.user;
}

export async function getUserProfile(): Promise<UserProfile> {
  const data = await apiClient.get<ProfileResponse>('/user/profile');
  return data.profile;
}

export async function createUser(username: string): Promise<User> {
  const data = await apiClient.post<UserResponse>('/user/create', { username });
  return data.user;
}

export async function repairUser(): Promise<User> {
  const data = await apiClient.post<UserResponse>('/user/repair');
  return data.user;
}

export async function updateUsername(username: string): Promise<User> {
  const data = await apiClient.put<UserResponse>('/user', { username });
  return data.user;
}

// Cooking activity
export async function getCookingActivity(): Promise<CookingActivityResponse> {
  return apiClient.get<CookingActivityResponse>('/cooking-activity');
}

export async function logCookingActivity(recipeId: string): Promise<void> {
  await apiClient.post('/cooking-activity', { recipe_id: recipeId });
}

// History transfer (for guest users logging in)
export async function transferGuestHistory(recipeIds: string[]): Promise<void> {
  await apiClient.post('/history/transfer', { recipe_ids: recipeIds });
}
